// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","wrapper":"buttonGroup_wrapper__fUnAu","wrapper__button":"buttonGroup_wrapper__button__JvybQ"};